import { usePostSocketContext } from './usePostSocketContext';
export var useGetPerformerByEventOrByTimeout = function () {
    var setCurrentState = usePostSocketContext().setCurrentState;
    return function (action, postId, timeout) {
        var timer = setTimeout(function () {
            action && action();
            setCurrentState(null);
        }, timeout || 5000);
        setCurrentState({ postId: postId, action: action, timer: timer });
    };
};
//# sourceMappingURL=useGetPerformerByEventOrByTimeout.js.mapimport { usePostSocketContext } from './usePostSocketContext';
export var useGetPerformerByEventOrByTimeout = function () {
    var setCurrentState = usePostSocketContext().setCurrentState;
    return function (action, postId, timeout) {
        var timer = setTimeout(function () {
            action && action();
            setCurrentState(null);
        }, timeout || 5000);
        setCurrentState({ postId: postId, action: action, timer: timer });
    };
};
//# sourceMappingURL=useGetPerformerByEventOrByTimeout.js.map